import { createServerFn } from "@tanstack/react-start";
import { getCookie, setResponseHeader } from "@tanstack/react-start/server";
import { parseConsent } from "./cookie-consent";

/** Public, request-local preference only; no user data or external services. */
export const getInitialConsent = createServerFn({ method: "GET" }).handler(() => {
  setResponseHeader("Cache-Control", "private, no-store");
  const raw = getCookie("consent");
  try { return parseConsent(raw ? decodeURIComponent(raw) : null); }
  catch { return null; }
});